// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider  } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAL0hnRNISrL4pWNycO607oI2yH3bTjpGI",
  authDomain: "parrotai-433712.firebaseapp.com",
  projectId: "parrotai-433712",
  storageBucket: "parrotai-433712.firebasestorage.app",
  messagingSenderId: "283170355185",
  appId: "1:283170355185:web:a221cefb9412cbb27cf650",
  measurementId: "G-NZNPHW1MFT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { app, db, storage, auth, functions, googleProvider };